<template>
    <div class="pt-3 px-3">
        <h6
            style="font-family: MainFontBold, sans-serif;
            font-size: 16px;
            color: #2A2A2A;">
            Basic Details
        </h6>
        <b-form-group
            id="productNameGroup"
            label="Product Name"
            label-for="productName"
            class="secondary-label"
            :invalid-feedback="errorMessage('name')"
            :state="isValid('name')">
            <b-form-input 
                id="productName"
                type="text"
                maxlength="40"
                required
                :disabled="editingFromLocationsPage"
                v-model="values.name">
            </b-form-input>
        </b-form-group>
        <b-form-group
            id="descriptionGroup"
            label-for="description"
            :label="'Description ' + descriptionLabel"
            class="secondary-label"
            :invalid-feedback="errorMessage('description')"
            :state="isValid('description')">
            <b-form-textarea
                placeholder="Enter description"
                :rows="3"
                :max-rows="6"
                :maxlength="max_descriptiion"
                :disabled="editingFromLocationsPage"
                v-model="values.description">
            </b-form-textarea>
        </b-form-group>
        <b-form-group
            label="Category"
            label-for="category_id"
            class="secondary-label mb-2"
            :invalid-feedback="errorMessage('category_id')"
            :state="isValid('category_id')">
            <b-form-select
                v-model="values.category_id"
                :options="category_options"
                :disabled="editingFromLocationsPage">
            </b-form-select>
        </b-form-group>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ProductBasicDetails",
    props: ["values", "origin"],
    data() {
        return {
            max_descriptiion: 300,
            initial_category: {
                value: null,
                text: "Select Category",
                disabled: true
            },
            category_options: []
        };
    },
    computed: {
        ...mapState("dstoreInventories", ["categories", "errors"]),
        ...mapState("estoreLocations", ["editingFromLocationsPage"]),
        descriptionLabel: {
            get: function() {
                if (this.values.description != null) {
                    return (
                        this.values.description.length +
                        " / " +
                        this.max_descriptiion
                    );
                }
                return "0 / " + this.max_descriptiion;
            }
        }
    },
    methods: {
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        }
    },
    watch: {
        categories: function() {
            this.category_options.push(this.initial_category);

            this.categories
                .map(category => {
                    return {
                        value: category.id,
                        text: category.name
                    };
                })
                .map(category => {
                    this.category_options.push(category);
                });

            // console.log(this.category_options);
        }
    }
};
</script>
